/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ProductListItem_user$ref = any;
export type ImageGallery_user$ref = any;
export type ImageGallery_user = {
    readonly role: string | null;
    readonly conciergeCustomerAccountId: string | null;
    readonly conciergeUser: ({
        readonly userId: string | null;
        readonly permissions: ({
            readonly id: string;
            readonly oneCommerce: ({
                readonly id: string;
                readonly preferredCustomer: ({
                    readonly access: boolean | null;
                }) | null;
            }) | null;
        }) | null;
    }) | null;
    readonly permissions: ({
        readonly id: string;
        readonly oneCommerce: ({
            readonly id: string;
            readonly ceo: ({
                readonly access: boolean | null;
            }) | null;
            readonly preferredCustomer: ({
                readonly access: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly cartV2: ({
        readonly id: string;
        readonly cartId: string | null;
        readonly autoShipEnabled: boolean | null;
        readonly autoShipIntervalUnit: string | null;
        readonly autoShipIntervalCount: number | null;
        readonly promoCodeSavings: number | null;
        readonly saleSavings: number | null;
        readonly canSubscribeForAutoShip: boolean | null;
        readonly discountQualifiedCartTotal: number | null;
        readonly subTotalPriceOfItems: number | null;
        readonly subTotalPriceOfItemsWithDiscount: number | null;
        readonly total: number | null;
        readonly totalSavings: number | null;
        readonly totalNumberOfItems: number | null;
        readonly eventId: string | null;
        readonly eventHostFirstName: string | null;
        readonly event: ({
            readonly id: string;
            readonly eventId: string | null;
            readonly trinityPartyType: string | null;
        }) | null;
        readonly promoCodes: ReadonlyArray<({
            readonly id: string;
            readonly code: string | null;
            readonly promoDescription: string | null;
            readonly thresholds: ReadonlyArray<({
                readonly discountAmount: string | null;
                readonly discountAmountEach: string | null;
            }) | null> | null;
        }) | null> | null;
        readonly wordPressCoupons: ReadonlyArray<({
            readonly code: string | null;
            readonly couponDescription: string | null;
            readonly storeBalance: number | null;
            readonly yotpoCouponCode: string | null;
        }) | null> | null;
        readonly wordPressCouponSavings: ReadonlyArray<number | null> | null;
        readonly entries: ({
            readonly edges: ReadonlyArray<({
                readonly node: ({
                    readonly id: string;
                    readonly sku: string | null;
                    readonly productId: string | null;
                    readonly quantity: number | null;
                    readonly productName: string | null;
                    readonly productURLslug: string | null;
                    readonly productImageUrl: string | null;
                    readonly wineBottleQuantity: number | null;
                    readonly isWinePack: boolean | null;
                    readonly priceOriginal: number | null;
                    readonly priceSale: number | null;
                    readonly priceDiscount: number | null;
                    readonly discountEligible: boolean | null;
                    readonly priceDiscountPercent: number | null;
                    readonly hasQualifyingDiscount: boolean | null;
                }) | null;
            }) | null> | null;
        }) | null;
    }) | null;
    readonly " $fragmentRefs": ProductListItem_user$ref;
    readonly " $refType": ImageGallery_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v1 /*: any*/)
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ImageGallery_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ProductListItem_user",
                "args": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "conciergeCustomerAccountId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "conciergeUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "userId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "permissions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PermissionsType",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "oneCommerce",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OneCommerceType",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v2 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "permissions",
                "storageKey": null,
                "args": null,
                "concreteType": "PermissionsType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "oneCommerce",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OneCommerceType",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ceo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": (v1 /*: any*/)
                            },
                            (v2 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "cartV2",
                "storageKey": null,
                "args": null,
                "concreteType": "CartV2",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subTotalPriceOfItemsWithDiscount",
                        "args": null,
                        "storageKey": null
                    },
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "autoShipEnabled",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "autoShipIntervalUnit",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "autoShipIntervalCount",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "promoCodeSavings",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "saleSavings",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canSubscribeForAutoShip",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountQualifiedCartTotal",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subTotalPriceOfItems",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cartId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "total",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalSavings",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalNumberOfItems",
                        "args": null,
                        "storageKey": null
                    },
                    (v3 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventHostFirstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v3 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "trinityPartyType",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "promoCodes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PromoCode",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            (v4 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "promoDescription",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "thresholds",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PromoCodeThresholds",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "discountAmount",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "discountAmountEach",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "wordPressCoupons",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WordPressCoupon",
                        "plural": true,
                        "selections": [
                            (v4 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "couponDescription",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "storeBalance",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "yotpoCouponCode",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "wordPressCouponSavings",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "entries",
                        "storageKey": "entries(first:1000)",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000,
                                "type": "Int"
                            }
                        ],
                        "concreteType": "CartEntryV3Connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CartEntryV3Edge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "CartEntryV3",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "wineBottleQuantity",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productId",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "quantity",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productName",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productURLslug",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "productImageUrl",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "sku",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "isWinePack",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceOriginal",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceSale",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceDiscount",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "discountEligible",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "priceDiscountPercent",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "hasQualifyingDiscount",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '27fa26d2418f9e1077743101d6fe8113';
export default node;
